"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnGbUsd = exports.EnGbEur = exports.EnGbGbp = void 0;
class EnGbGbp {
    constructor() {
        this.locale = "en-gb";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "MMMM dd, yyyy",
            long: "dd MMMM yyyy",
        };
        this.currencyFormat = {
            code: "GBP",
            symbol: "£",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "C n",
            negativePattern: "-C n"
        };
    }
}
exports.EnGbGbp = EnGbGbp;
class EnGbEur {
    constructor() {
        this.locale = "en-gb";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "MMMM dd, yyyy",
            long: "dd MMMM yyyy",
        };
        this.currencyFormat = {
            code: "EUR",
            symbol: "EUR",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "C n",
            negativePattern: "-C n"
        };
    }
}
exports.EnGbEur = EnGbEur;
class EnGbUsd {
    constructor() {
        this.locale = "en-gb";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "MMMM dd, yyyy",
            long: "dd MMMM yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "USD",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "C n",
            negativePattern: "-C n"
        };
    }
}
exports.EnGbUsd = EnGbUsd;
